import { LatLng } from "use-places-autocomplete";

export const stringifyCoordinates = (coords: LatLng | undefined | null) => {
  if (!coords) return null;

  return `${coords.lat},${coords.lng}`;
};

export const parseCoords = (
  coords: string | null | undefined
): LatLng | null => {
  if (!coords) return null;

  try {
    if (coords.includes("lat")) {
      return JSON.parse(coords);
    }

    const coords_in_arr = coords.split(",");
    const lat = +coords_in_arr[0] || null;
    const lng = +coords_in_arr[coords_in_arr.length - 1] || null;

    if (!lat || !lng) return null;

    return {
      lat: lat,
      lng: lng
    };
  } catch (error) {
    return null;
  }
};
